import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { baseUrl } from "../../../enum/constant";

const Transaction = () => {
    const [cryptocurrencies, setCryptocurrencies] = useState([]);
    const [selectedCrypto, setSelectedCrypto] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [searchText, setSearchText] = useState("");
    const [uploadingRows, setUploadingRows] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [hashTransactionId, setHashTransactionId] = useState("");

    useEffect(() => {
        fetchCryptocurrencies();
        fetchTransactions();
    }, []);

    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [showPopup]);

    useEffect(() => {
        filterTransaction();
    }, [searchText, transactions, selectedCrypto]);

    const filterTransaction = () => {
        let arr = []
        if (selectedCrypto?.symbol) {
            // console.log(selectedCrypto?.symbol, "selectedCrypto?.symbol", transactions);

            const filterTr = transactions.filter((transaction) =>
                transaction.criptoname.toLowerCase() == selectedCrypto?.symbol?.toLowerCase()
            );
            arr = filterTr;
        } else {
            arr = transactions;
        }

        const filteredTrans = arr.filter((transaction) =>
            transaction.email.toLowerCase().includes(searchText.toLowerCase()) ||
            transaction.id.toString().includes(searchText) ||
            transaction.transaction_type.toLowerCase().includes(searchText.toLowerCase()) ||
            transaction.hash_transaction_id?.toLowerCase().includes(searchText.toLowerCase()) ||
            transaction.currencyname.toLowerCase().includes(searchText.toLowerCase()) ||
            transaction.criptoname.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredTransactions(filteredTrans);
    };

    const handleCryptoChange = (selectedOption) => {
        setSelectedCrypto(selectedOption);
    };

    const fetchCryptocurrencies = async () => {
        try {
            const base = baseUrl;
            const cryptoApiUrl = base + 'api/crypto-currencies';
            const response = await axios.get(cryptoApiUrl);
            const coinsWithIds = response.data
                .filter(coin => ['BTC', 'USDT', 'ETH', 'USDC'].includes(coin.symbol))  // Filter by symbol
                .map(coin => ({
                    ...coin,
                    id: coin.id, // Ensure each coin object has an 'id'
                }));
            setCryptocurrencies(coinsWithIds);

            // const bitcoin = coinsWithIds.find(coin => coin.symbol === 'BTC');
            // setSelectedCrypto(bitcoin);
        } catch (error) {
            // setError('Error fetching cryptocurrencies. Please try again later.');
        } finally {
            // setLoading(false);
        }
    };

    const fetchTransactions = async () => {
        try {
            const response = await axios.get(
                baseUrl + "api/transactionsbyid",
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
            setTransactions(response.data.transactions);
        } catch (err) {
            setError("Failed to fetch transactions");
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = async (e, transactionId, email) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) {
            setFile(null);
            return;
        }

        setFile(selectedFile);
        setUploadingRows((prev) => ({ ...prev, [transactionId]: true }));

        const formData = new FormData();
        formData.append("payment_prof", selectedFile);
        formData.append("id", transactionId);
        formData.append("status", 2);
        formData.append("email", email);

        try {
            await axios.post(
                baseUrl + "api/upload-payment-prof",
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            setSuccessMessage("File uploaded successfully!");
            fetchTransactions();
        } catch (err) {
            console.error(err);
            setSuccessMessage("Failed to upload file.");
        } finally {
            setUploadingRows((prev) => ({ ...prev, [transactionId]: false }));
            setTimeout(() => setSuccessMessage(""), 3000);
            setFile(null);
        }
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const handlePopupToggle = (transaction) => {
        setSelectedTransaction(transaction);
        setHashTransactionId(transaction.hash_transaction_id || "");
        setShowPopup(!showPopup);
    };

    const handleUpdateHashTransactionId = async () => {
        if (!hashTransactionId.trim()) {
            alert("Please enter a valid transaction ID.");
            return;
        }

        // Prepare the data to send to the server
        const dataToSend = {
            hash_transaction_id: hashTransactionId,
            id: selectedTransaction.id,
            email: selectedTransaction.email,
        };

        try {
            // Send the post request to update the hash_transaction_id
            await axios.post(
                baseUrl + "api/hash-TransictionId",
                dataToSend,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
            setSuccessMessage("Transaction Hash ID updated successfully!");
            fetchTransactions(); // Reload transactions after update
            setShowPopup(false); // Close the popup modal
        } catch (error) {
            console.error(error);
            setSuccessMessage("Failed to update hash transaction ID.");
        } finally {
            setTimeout(() => {
                setSuccessMessage("");
            }, 5000);
        }
    };

    const getStatus = (status) => {
        switch (status) {
            case 0:
                return "Pending";
            case 1:
                return "Completed";
            case 2:
                return "Reviewing";
            case 3:
                return "Rejected";
            default:
                return "Unknown";
        }
    }

    const getStatusClass = (status) => {
        switch (status) {
            case 0:
                return " text-warning";
            case 1:
                return " text-success";
            case 2:
                return " text-info";
            case 3:
                return " text-danger";
            default:
                return " text-info";
        }
    }

    if (loading) return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><div className="alert alert-info">Loading...</div></div></div>;
    if (error) {
        return (
            <div className="mt-md-5 pt-md-5">
                <div className="mt-md-5">
                    <div className="alert alert-danger bg-secondary text-white border-0">
                        No Transaction found.
                        {/* {error} */}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="check-box mb-5">
                <div className="inner-box">
                    <h5>Enter your wallet address to get the status</h5>
                    <div className="row g-3 mt-3">
                        <div className="col-md-8">
                            <div className="field-bg">
                                <span>Hash transaction</span>
                                <input
                                    value={searchText}
                                    onChange={handleSearch}
                                    type="text" className="form-control" placeholder="0xABC123..." />
                            </div>

                        </div>
                        <div className="col-md-4">
                            <div className="field-bg">
                                {/* <span>Select Blockchain</span>
                                <select className="form-select">
                                    <option>Tether TRC20</option>
                                </select> */}
                                <div className="dropdown sik-dropdown">
                                    <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        style={
                                            { background: "none" }
                                        }
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        {selectedCrypto ? (
                                            <>
                                                <img className="crypto-icon" src={selectedCrypto.logo} alt={selectedCrypto.symbol} />
                                                {selectedCrypto.symbol}
                                            </>
                                        ) : 'Select Crypto'
                                        }
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-dark buyget">
                                        <li>
                                            <span
                                                className="dropdown-item"
                                                onClick={() => handleCryptoChange(null)}
                                            >
                                                Select Crypto
                                            </span>
                                        </li>
                                        {cryptocurrencies.map((item) => (
                                            <li key={item.symbol}>
                                                <span
                                                    className="dropdown-item"
                                                    onClick={() => handleCryptoChange(item)}
                                                >
                                                    <img className="crypto-icon" src={item.logo} alt={item.symbol} />
                                                    {item.symbol}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                    <center><div className="button-group">
                        <Link to="#" className={`btn grey-btn cus-grey-btn ${(searchText && selectedCrypto?.symbol) ? 'btn-hovered' : ''}`}>Check</Link>
                    </div></center>
                </div>
            </div>

            <div className="history-section cus-history-section">
                {successMessage && (
                    <div
                        className={`cus-alert-msg ${successMessage.includes("successfully")
                            ? "alert-success"
                            : "alert-danger"
                            }`}
                        role="alert">
                        <div class="icon">
                            {successMessage.includes("successfully") ? '✔' : '✖'}
                            {/* <i class="bi bi-check-lg"></i> */}
                        </div>
                        <p class="message mb-0">{successMessage}</p>
                    </div>
                )}
                <h2>Transaction history</h2>
                {
                    !filteredTransactions?.length ? (

                        <div className="hide-click-check">
                            <img src="assets/images/transaction-icon.png" alt="No data" />
                            <p><strong>No Transactions Yet</strong></p>
                            <p>Once you start exchanging crypto or fiat, your transactions will appear here.<br />Track your activity, statuses, and details all in one place.</p>

                            <div className="btn-part">
                                <Link to="/" className="btn buy-btn">Make your first exchange</Link>
                            </div>
                        </div>
                    ) : (
                        <div className="hisrory-cards">
                            {
                                filteredTransactions?.map((tran) => (
                                    <div className="transaction-card">
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <div className="label">Order №</div>
                                                <div className="value">Order {tran.id}</div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="label">Created at</div>
                                                <div className="value">{new Date(tran.created_at).toISOString().split('T')[0]}</div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="label">Hash transaction</div>
                                                <div className="value hash-copy"> {tran.hash_transaction_id} {" "}
                                                    {
                                                        tran.hash_transaction_id && (
                                                            <i className=""><img src="assets/images/copy.png" /></i>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-3 text-end cus-status-color" style={{
                                                display: "flex",
                                                alignItems: "end",
                                                flexDirection: "column"
                                            }}>
                                                <div className="label">Status</div>
                                                <div className={"value status-completed" + (getStatusClass(tran.status))}>
                                                    {getStatus(tran.status)}
                                                    {/* <i className="bi bi-check-circle-fill status-icon"></i> */}
                                                </div>
                                            </div>
                                        </div>

                                        <hr />

                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <div className="label">Send</div>
                                                <div className="value currency">
                                                    <img width={20} src="assets/images/BTC.png" alt="" />
                                                    {/* 0.8564 BTC */}
                                                    {
                                                        tran.transaction_type === "buy" ?
                                                            parseFloat(tran.crypto_amount) + " " + tran.currencyname
                                                            : parseFloat(tran.crypto_amount) + " " + tran.criptoname
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="label">Receive</div>
                                                <div className="value currency">
                                                    <img width={20} src="assets/images/European union.png" alt="" />
                                                    {/* 83 070,95 EUR */}
                                                    {
                                                        tran.transaction_type === "buy" ?
                                                            parseFloat(tran.converted_amount) + " " + tran.criptoname
                                                            : parseFloat(tran.converted_amount) + " " + tran.currencyname
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 text-end" style={{
                                                display: "flex",
                                                alignItems: "end",
                                                flexDirection: "column"
                                            }}>
                                                <div className="label">Payment proof</div>
                                                <div className="value d-flex">
                                                    {/* {tran.transaction_type === "sell" ? (
                                                        <button
                                                            onClick={() => handlePopupToggle(tran)}
                                                            style={{
                                                                display: "inline-block",
                                                                cursor: "pointer",
                                                                padding: "5px 3px",
                                                                backgroundColor: "#0dcaf0",
                                                                color: "white",
                                                                borderRadius: "5px",
                                                                border: "none",
                                                            }}
                                                        >
                                                            Add Hash
                                                        </button>
                                                    ) : (
                                                        <div className="tyuy">
                                                            <input
                                                                type="file"
                                                                name="payment_prof"
                                                                id={`file-input-${tran.id}`}
                                                                onChange={(e) => handleFileChange(e, tran.id, tran.email)}
                                                                accept="image/*, application/pdf"
                                                                style={{ display: "none" }}
                                                            />
                                                            <label
                                                                htmlFor={`file-input-${tran.id}`}
                                                                style={{
                                                                    display: "inline-block",
                                                                    cursor: "pointer",
                                                                    padding: "5px 10px",
                                                                    backgroundColor: "#4CAF50",
                                                                    color: "white",
                                                                    borderRadius: "5px",
                                                                }}
                                                            >
                                                                Upload
                                                            </label>
                                                            {uploadingRows[tran.id] && <span className="ml-2">Uploading...</span>}
                                                        </div>
                                                    )} */}
                                                    {
                                                        tran.payment_prof && (
                                                            <a
                                                                href={`${baseUrl}storage/${tran.payment_prof}`}
                                                                // href={`${baseUrl}storage/app/public/${tran.payment_prof}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="ml-2"
                                                                // className="btn btn-link text-primary d-flex align-items-center"
                                                                style={{
                                                                    fontSize: "14px",
                                                                    fontWeight: "bold",
                                                                    padding: "0",
                                                                    textDecoration: "none",
                                                                }}
                                                            >
                                                                {/* <i
                                                                    className="bi bi-file-earmark-check"
                                                                    style={{ marginRight: "5px", fontSize: "x-large" }}
                                                                ></i>{" "} */}
                                                                Transaction_document.pdf <i className="bi bi-download"></i>
                                                            </a>
                                                        )
                                                    }
                                                    <div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    )
                }

            </div>

            {showPopup && selectedTransaction && (
                <div>
                    {/* Overlay Background */}
                    <div className="overlay-background" style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 999
                    }}></div>

                    {/* Modal */}
                    <div className="modal hash-transh" style={{ display: "block", paddingRight: "0px", zIndex: 1000 }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-titl hdt">Transaction Details</h5>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label htmlFor="hashTransactionId" className="hdt">Hash Transaction ID:</label>
                                        <input
                                            type="text"
                                            id="hashTransactionId"
                                            value={hashTransactionId}
                                            onChange={(e) => setHashTransactionId(e.target.value)}
                                            className="form-control" placeholder="hash Transaction Id"
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={handlePopupToggle}>
                                        Close
                                    </button>
                                    <button className="btn btn-primary cus-btn-hover-affect" onClick={handleUpdateHashTransactionId}>
                                        Save/Update Hash
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default Transaction;
